module.exports = __webpack_public_path__ + "static/media/cover-login-access-3.fa9fb1ae.jpg";